import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="d-flex align-items-center justify-content-center">
      <div className="text-center">
        <img
          src="/img/not_found.png" // Replace this with your own 404 image if available
          alt="404 Not Found"
          className="img-fluid mb-4"
          style={{ maxWidth: '350px' }}
        />
        <p></p>
        <Link to="/" className="btn btn-primary rounded-pill mt-4 py-3 px-5">
          Go to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
